import React from 'react';
import { KiteGrid, KiteGridCell } from '@kite/react-kite';
import styles from 'components/footer/styles/Footer.module.scss';
import SocialMedia from 'components/footer/SocialMedia';
import {
  getPortalSupportLinkAccessibility,
  getPortalSupportLinkAccount,
  getPortalSupportLinkInternet,
  getPortalSupportLinkMobile,
  getPortalSupportLinkTV,
  getPortalSupportLinkVoice,
  getPortalWatchTVLinkDVR,
  getPortalWatchTVLinkGuide,
  getPortalWatchTVLinkLiveTV,
  getPortalWatchTVLinkMyLibrary,
  getPortalWatchTVLinkOnDemand,
  LinkItemInterface,
} from 'app-constants';
import SpectrumColumn from './SpectrumColumn';
import { isSMBPortal } from 'utils/applicationHelper';

const SpectrumLinks: React.FC = () => {
  const isSMB = isSMBPortal();

  const supportLinks: LinkItemInterface[] = [
    getPortalSupportLinkAccount(),
    getPortalSupportLinkInternet(),
    getPortalSupportLinkTV(),
    getPortalSupportLinkVoice(),
  ];

  if (!isSMB) {
    supportLinks.push(getPortalSupportLinkMobile());
  }

  supportLinks.push(getPortalSupportLinkAccessibility());

  const watchTvLinks: LinkItemInterface[] = [];
  if (!isSMB) {
    watchTvLinks.push(getPortalWatchTVLinkLiveTV());
    watchTvLinks.push(getPortalWatchTVLinkGuide());
    watchTvLinks.push(getPortalWatchTVLinkMyLibrary());
    watchTvLinks.push(getPortalWatchTVLinkOnDemand());
    watchTvLinks.push(getPortalWatchTVLinkDVR());
  }

  return (
    <KiteGridCell col={12}>
      <KiteGrid className={styles.footerColumns}>
        <SpectrumColumn links={supportLinks} title={'getSupport'} />
        {!isSMB && <SpectrumColumn links={watchTvLinks} title={'watchTv'} />}
        <SocialMedia />
      </KiteGrid>
    </KiteGridCell>
  );
};

export default SpectrumLinks;
